import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgLucideCalendarRange = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <rect width={18} height={18} x={3} y={4} rx={2} />
      <path d="M16 2v4M3 10h18M8 2v4m9 8h-6m2 4H7m0-4h.01M17 18h.01" />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgLucideCalendarRange);
const Memo = memo(ForwardRef);
export default Memo;
